module.exports = __webpack_public_path__ + "img/top4.626c9ab7.svg";